<template>

    <div class="hardcodedHeightContainer">
        <v-tabs
            grow
            dark
            :slider-color="$colors.yellow"
            v-model="tab"
            :background-color="$colors.sky_blue_1"
            @change="updatePageAndScrollDelayed"
        >
            <v-tab key="procedurelist">
                Step List
            </v-tab>
            <v-tab key="handbook">
                Handbook
            </v-tab>
        </v-tabs>

        <div v-if="tab===1 && (hasLoaded && handbookUrl && !noManualFound)" style="margin: 10px">
            <v-btn x-small @click="prevPage">
                <LATIcon icon="caret-left"/>
            </v-btn>

            Page {{ page }} of {{ numPages }}

            <v-btn x-small @click="nextPage">
                <LATIcon icon="caret-right"/>
            </v-btn>

            <div style="margin-left: 20px; display: inline-block">
                <v-btn x-small @click="zoom -= 10">
                    <LATIcon icon="magnifying-glass-minus"/>
                </v-btn>

                <v-btn x-small @click="zoom += 10">
                    <LATIcon icon="magnifying-glass-plus"/>
                </v-btn>
            </div>
            <v-btn x-small color="primary" @click="toggleShowEntireManual"
                   style="margin-left: 5px">
                {{ !isShowingEntireManual ? 'Open entire manual' : 'Back to detail view' }}
            </v-btn>
        </div>

        <vue-scroll ref="container">

            <v-tabs-items v-model="tab" class="handbookwidthMinusTab">

                <v-tab-item key="procedurelist">

                    <div v-if="!procedure.steps || procedure.steps.length === 0">

                        <div style="margin-top: 25px">

                            <v-img src="/graphics/dinner-for-one-butler-james.jpeg" height="50vh" contain/>
                            <span>{{ procedure.name }}</span>
                            <span>Procedure does not exist in this prototype</span>
                        </div>


                    </div>

                    <div v-else>

                        <v-timeline
                            align-top
                            dense
                        >
                            <v-timeline-item
                                small
                                v-for="(step, stepIdx) in procedure.steps"
                                v-bind:key="stepIdx"
                                :ref="stepIdx + '-ref'"
                                style="cursor: pointer"
                                @click.native="startProcedureFromStep(stepIdx)"
                            >

                                <template v-slot:icon>
                                    <v-avatar
                                        rounded
                                        size="30"
                                        style="color: white"
                                        :color="selectedProcedureStep && selectedProcedureStep.stepIdx === stepIdx ? $colors.yellow : $colors.sky_blue_1"
                                    >{{ stepIdx + 1 }}
                                    </v-avatar>
                                </template>

                                <v-card style="margin-right: 16px; background: white" color="white">
                                    <div v-if="stripHtmlFromString(step.pretitle)" v-html="step.pretitle"
                                         class="text-xs pretitle"/>
                                    <h3 style="margin-top: -16px">
                                        {{ step.message }}
                                    </h3>
                                    <div v-html="step.todo"/>
                                </v-card>

                            </v-timeline-item>

                        </v-timeline>
                    </div>

                    <div style="margin-top: 100px">&nbsp;</div>

                </v-tab-item>


                <v-tab-item key="handbook">
                    <div v-if="!hasLoaded && handbookUrl" class="loading-spinner">
                        <loading-spinner color="#3588C9"/>
                    </div>
                    <div v-else-if="(!hasLoaded && !url) || hasLoaded && noManualFound" class="mt-2">
                        No handbooks have been selected for the current procedure
                    </div>

                    <pdf
                        v-if="handbookkey && url"
                        style="overflow:scroll;"
                        class="pdfviewer" :src="url"
                        ref="pdf" :style="`width: ${zoom}%`"
                        :page="page"
                        @progress="progress"
                        @error="pdfError"
                        @num-pages="numPages = $event"
                        @link-clicked="page = $event"
                        @key="url"
                    />

                </v-tab-item>

            </v-tabs-items>

        </vue-scroll>

    </div>

</template>

<script>

import {aircraftConfig, settings} from "../config";
import LATIcon from "./Icon/LATIcon";
import {procedureTeacher} from "@/modules/ProcedureTeacher";
import pdf from "vue-pdf";
import LoadingSpinner from "vue-spinner/src/ClipLoader";
import Vue from "vue";

export default {
    name: "Handbook",
    props: ['teacher'],
    $emit: ['start-from-step'],
    components: {pdf, LoadingSpinner, LATIcon},
    computed: {
        procedure() {
            return this.$store.state.currentProcedure
        },
        selectedProcedureStep() {
            return procedureTeacher.getStep();
        },
        settings() {
            return settings;
        },
        stripHtmlFromString() {
            return html => {
                if (html) {
                    return html.replace(/(<([^>]+)>)/ig, '')
                } else {
                    return ''
                }
            }
        },
        handbookkey() {
            return this.procedure.handbookkey;
        },
        handbooks() {
            return aircraftConfig.getConfig().handbooks
        },
        handbookStartPage(){
            return this.isShowingEntireManual ? this.procedure.page_start : 1;
        },
        handbookUrl() {
            if (this.isShowingEntireManual) {
                const handbook = this.handbooks.find(h => h.key === this.handbookkey)
                return handbook ? handbook.url : null
            } else {
                return this.procedure.handbookPart
            }
        }
    },
    data: () => ({
        tab: 0,
        loadedRatio: 0,
        numPages: 0,
        zoom: 100,
        page: 1,
        hasLoaded: false,
        pdfErr: null,
        isShowingEntireManual: false,
        noManualFound: false,
        url: null
    }),
    mounted() {
        this.updatePageAndScroll()
    },
    methods: {
        nextPage() {
            if (this.page < this.numPages) {
                this.page++
            }
        },
        prevPage() {
            if (this.page > 1) {
                this.page--
            }
        },
        toggleShowEntireManual() {
            this.isShowingEntireManual = !this.isShowingEntireManual;
            this.setPage()
        },
        pdfError: function (err) {
            // eslint-disable-next-line no-console
            Vue.$log.error('pdf error', err)
        },
        progress($event) {
            this.loadedRatio = $event
            this.hasLoaded = this.loadedRatio >= 1;
        },
        updatePageAndScrollDelayed() {
            setTimeout(() => this.updatePageAndScroll(), 100);
        },
        setPage(page){
            this.page = 1
            this.url = this.handbookUrl
            this.page = Number(page ? page : this.handbookStartPage)
        },
        updatePageAndScroll() {

            this.setPage()
            if (this.selectedProcedureStep) {
                /* page number from step if existent, otherwise keep current */
                if (this.selectedProcedureStep && this.selectedProcedureStep.data) {

                    let data = typeof this.selectedProcedureStep.data === 'string' ? JSON.parse(this.selectedProcedureStep.data) : this.selectedProcedureStep.data
                    if(data.length > 0 && data[0].attributes && data[0].attributes.page){
                        const realPage = this.isShowingEntireManual ? data[0].attributes.page : data[0].attributes.page - this.procedure.page_start + 1
                        this.setPage(realPage)
                    }
                }

                /* scroll to procedure step if tab active */
                if (this.tab === 0) {   // steplist
                    const currentRef = this.selectedProcedureStep.stepIdx + '-ref';
                    if (this.$refs['container'] && this.$refs[currentRef] && this.$refs[currentRef].length > 0) {
                        const scrollRef = this.$refs['container'];
                        const yPos = this.$refs[currentRef][0].$el.offsetTop;
                        scrollRef.scrollTo({y: yPos - 100}, 0)
                    }
                }
            }
        },
        startProcedureFromStep(stepIdx) {
            this.$emit('start-from-step', stepIdx)
        },
    }
}
</script>

<style scoped lang="less">

.hardcodedHeightContainer {

}

.pdfviewer {
    display: inline-block;
    width: 100%;
}

.loading-spinner {
    margin: 10% auto;
}

</style>
